import React from "react";
import { ICompanyInfo } from "../../services/types/LeadRequisitionType";
import { Card, Icon } from "@citi-icg-172888/icgds-react";
import { useData } from "../../services/context/DataContext";
import { createAddress } from "../../utils/companyUtils";

interface BusinessCardProps {
  companyData: any;
  setSearchBusiness: React.Dispatch<React.SetStateAction<boolean>>;
  setValue: React.Dispatch<React.SetStateAction<any[] | never[]>>;
  id: any;
}

const BusinessCard = React.forwardRef<HTMLDivElement, BusinessCardProps>((props, ref) => {
  const { companyData, setSearchBusiness, setValue, id } = props;
  const { setCompanyInfo } = useData();

  const onChangeCompanyData = () => {
    const updateCompanyInfo = {
      global_ultimate_country_name: companyData.global_ultimate_country_name,
      businessInfo: companyData.businessInfo,
    } as ICompanyInfo;
    setCompanyInfo(null);
    setValue([]);
    setSearchBusiness(false);
    setCompanyInfo(updateCompanyInfo);
  };

  return (
    <Card
      className="dnca-lmn-rounded-8 lmn-w-90 lmn-dcna-m-flex-container"
      aria-describedby={id}
      tabIndex={0}
      ref={ref}
    >
      <div className="lmn-dcna-m-flex-container lmn-dcna-s-flex-container lmn-row dynamic-width" id={id}>
        <div className="lmn-font-size-lg lmn-dnca-w-l-50 lmn-dnca-w-m-75 lmn-font-weight-bold label third">
          {companyData.legalNameOfBusiness}
        </div>
        <div
          id="business_change_icon"
          className="first lmn-dnca-w-l-50 lmn-text-lg-right lmn-text-xl-right lmn-text-md-right lmn-text-2xl-right"
          style={{ cursor: "pointer", color: "#3399ff", backgroundColor: "#0f1632" }}
          onClick={onChangeCompanyData}
          aria-label="Change Company Name"
          role="button"
          tabIndex={0}
        >
          <a
            className="lmn-text-link-quiet lmn-text-color lmn-hover-underline"
            style={{ color: "#fff !important" }}
            target="_blank"
          >
            <Icon type="edit" alt="icon presenting Change business" aria-hidden="true" /> Change
          </a>
        </div>
        <div className="label second">
          <div className="">
            {companyData.address || (!companyData.address && createAddress(companyData))}
          </div>
          <div className="">{companyData.headquaterCountry}</div>
        </div>
      </div>
    </Card>
  );
});

export default BusinessCard;
